import { FC } from "react";
import { useTranslation } from "react-i18next";
import tw from "twin.macro";

export const Empty: FC = ({ children }) => {
  const { t } = useTranslation("@jobook-io/jobook-job-card");
  return <span css={tw`text-gray-300`}>{children || t("shared.empty")}</span>;
};
